interface FilledChevronProps {
  direction?: 'left' | 'right'
  disabled?: boolean
}

export function FilledChevron({
  direction = 'right',
  disabled = false,
}: FilledChevronProps) {
  return (
    <svg
      width="31"
      height="32"
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={direction === 'left' ? '-scale-x-100' : undefined}
      aria-hidden="true"
    >
      <path
        d="M17.0139 16L10.6201 9.39998L12.4465 7.51465L20.6667 16L12.4465 24.4853L10.6201 22.6L17.0139 16Z"
        fill={disabled ? '#A4ADB7' : '#001018'}
      />
    </svg>
  )
}
